"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatSSN = void 0;
/**
 * Formats a given string.
 *
 * @param {string} value - The value to be formatted.
 * @returns {string} - The formatted date, or original/empty string based on conditions.
 */
const formatSSN = (value) => {
    if (!value)
        return "";
    return value.trim().replace(/[^\d]/g, "");
};
exports.formatSSN = formatSSN;
